const urlsData = {
    apis: {
        tasks: { url: "todos" },
    },
    routes: {
        home: "/",
        notFound: "/404",
        tasks: {
            create: "/tasks/create",
            edit: "/tasks/edit",
            url: "/tasks",
        },
    },
};

export default urlsData;
